function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useRef } from 'react';
import { useAccordionState } from '../use-accordion-state';
export var useAccordion = function useAccordion(_ref) {
  var _ref$openOnMount = _ref.openOnMount,
      openOnMount = _ref$openOnMount === void 0 ? false : _ref$openOnMount,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? openOnMount : _ref$open;
  var ref = useRef(null);

  var _useAccordionState = useAccordionState({
    openOnMount: openOnMount,
    open: open,
    ref: ref
  }),
      _useAccordionState2 = _slicedToArray(_useAccordionState, 2),
      state = _useAccordionState2[0],
      setState = _useAccordionState2[1];

  var handleToggle = useCallback(function (itemRef) {
    var _ref$current;

    // Find the index of the currently toggled item
    var items = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('[data-role="accordion-item"]'); // itemRef will be the header and should be contained in one of the items

    var index = Array.from(items || []).findIndex(function (item) {
      return item.contains(itemRef.current);
    });

    if (index !== -1) {
      setState(function (currentState) {
        return _objectSpread(_objectSpread({}, currentState), {}, _defineProperty({}, index, !currentState[index]));
      });
    }
  }, [ref, setState]);
  var isOpen = useCallback(function (itemRef) {
    var _ref$current2;

    // Find the index of the currently toggled item
    var items = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.querySelectorAll('[data-role="accordion-item"]'); // itemRef will be the header and should be contained in one of the items

    var index = Array.from(items || []).findIndex(function (item) {
      return item.contains(itemRef.current);
    });
    return state[index];
  }, [state]);
  return {
    ref: ref,
    state: state,
    handleToggle: handleToggle,
    isOpen: isOpen
  };
};